module.exports = __webpack_public_path__ + "img/bespoke70_01.abb9abf7.jpg";